import { featureCollections } from "@/mocks/homeData";

export default function FeatureCollections() {
  const [lead, ...rest] = featureCollections;

  return (
    <section id="collections" className="w-full border-b border-background-200/70 bg-background-50 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-6xl">
        <div className="mb-8 md:mb-10">
          <p className="mb-2 flex items-center gap-2 text-xs font-medium text-primary-600 md:text-sm">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-gallery-view-2 text-base" aria-hidden="true"></i>
            </span>
            模块 03 · 专题合集
          </p>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            专题合集 · 大图卡片流
          </h2>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            把同一题材下的零散线索收进一个专题，按时间线与争议点排序，适合一次性把来龙去脉看完。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-6">
          <a
            href="#latest"
            className="group relative flex min-h-[320px] flex-col justify-end overflow-hidden rounded-lg border border-background-200/80 md:min-h-[440px]"
          >
            <div className="absolute inset-0 h-full w-full">
              <img
                src={lead.image}
                alt={lead.title}
                title={`${lead.title} 专题合集`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/35 to-transparent"></div>
            </div>
            <div className="relative z-10 p-5 md:p-7">
              <span className="inline-block rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                {lead.tag}
              </span>
              <h3 className="mt-3 font-heading text-xl font-bold text-background-50 md:text-3xl">
                {lead.title}
              </h3>
              <p className="mt-2 max-w-lg text-sm leading-relaxed text-background-200 md:text-base">{lead.desc}</p>
              <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-background-300 md:text-sm">
                <span className="flex items-center gap-1.5">
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-stack-line text-base" aria-hidden="true"></i>
                  </span>
                  {lead.count}
                </span>
                <span className="flex items-center gap-1.5">
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-time-line text-base" aria-hidden="true"></i>
                  </span>
                  {lead.updated}
                </span>
              </div>
            </div>
          </a>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:gap-6">
            {rest.map((item, index) => (
              <a
                key={item.title}
                href="#latest"
                style={{ animationDelay: `${index * 60}ms` }}
                className="animate-fade-up group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors hover:border-primary-300"
              >
                <div className="h-40 w-full sm:h-44">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={`${item.title} 专题合集`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col p-4">
                  <span className="w-fit rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-900">
                    {item.tag}
                  </span>
                  <h3 className="mt-2 font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
                    {item.desc}
                  </p>
                  <div className="mt-3 flex items-center justify-between border-t border-background-200/70 pt-3 text-xs text-foreground-500">
                    <span>{item.count}</span>
                    <span>{item.updated}</span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}